import { Pipe, PipeTransform } from '@angular/core';
import { CalendarFilter } from '../state/calendar-filter/state';
import { MonitorFilter } from '../state/monitor-filters/state';

@Pipe({
  name: 'filterLabel'
})
export class FilterLabelPipe implements PipeTransform {
  transform(filter: CalendarFilter | MonitorFilter, args?: any): any {
    const { name, label, model } = filter;
    switch (name) {
      case 'ratings':
        return model.radio === 'all' ? 'Ratings' : 'Enhancement';
      default:
        return label;
    }
  }
}
